<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from  '@/components/business/sales/cost/list'

export default {
  name: "cost",
  mixins: [curdMixins],
  components: { list },
  methods: {
    
  }
};
</script>